import i18n from '../../language/index'
import img_effects from '@/base/img_effects'
import linkData from '@/base/linkData'
import { create_title } from '@/base/titleData';
export default {
  img_effects, //不知道这个是啥 但是去掉会报错
  pc_widgets_infor: {
     //标题对象
    title: create_title('Collapsed text'),
    /* icon_show: true, // 图标显示和隐藏
    icon_img: {
      radio_val: 'default',
      default: {
        img: 'https://sitecdn.71360.com/static/txys-001/image/icon_material/1/1_ (1).png',// 图标的URL
      },
      custom: {
        img: 'https://sitecdn.71360.com/static/txys-001/image/icon_material/1/1_ (1).png', // 图标的URL
      }
    }, */
    show_type: 'default', //展开方式
    //背景
    background:{
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      },
      custom:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      }
    },
    // 标题文字
    title_font: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        selectColor: 'rgba(156,40,177,1)',
        fontFamily: 'Arial',
        // textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        selectColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        // textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    // 内容文字
    content_font: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        selectColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        // textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        selectColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        // textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
  },
  mb_widgets_infor: {
     //标题对象
    title: create_title('Collapsed text'),
    /* icon_show: true, // 图标显示和隐藏
    icon_img: {
      radio_val: 'default',
      default: {
        img: 'https://sitecdn.71360.com/static/txys-001/image/icon_material/1/1_ (1).png',// 图标的URL
      },
      custom: {
        img: '', // 图标的URL
      }
    }, */
    /* show_type: 'default', //展开方式 // custom click点击展开
    //背景
    background:{
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      },
      custom:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      }
    }, */
    // 标题文字
    title_font: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        // selectColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        // textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        // selectColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        // textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    // 内容文字
    content_font: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        // selectColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        // textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        // selectColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        // textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
  },
  listArr: {
    link: linkData,
    title: i18n.t('widgets_basic_flod_text_edit_543'),
    content: i18n.t('widgets_basic_floating_frame_style_542'),
    icon_show: true, // 图标显示和隐藏
    icon_img: { // 图标显示 自定义 或者是默认
      radio_val: 'default',
      default: {
        img: 'https://sitecdn.71360.com/static/txys-001/image/icon_material/1/1_ (1).png',// 图标的URL
      },
      custom: {
        img: 'https://sitecdn.71360.com/static/txys-001/image/icon_material/1/1_ (1).png', // 图标的URL
      }
    },
  },
}


// WEBPACK FOOTER //
// ./src/widgets/basic_flod_text/style.js